import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer, createMigrate, createTransform } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import thunk from 'redux-thunk';
import rootReducer from './reducer';
import { NonPrimeHotelPropsDefault } from '../models';
import devtools from './devtools';

const migrations = {
    2: (state) =>( {
        ...state,
        currentSearch: {
            ...state.currentSearch,
            nonPrimeHotelRooms: {
                rooms: NonPrimeHotelPropsDefault.minRooms,
                adults: NonPrimeHotelPropsDefault.minAdults,
                kids: [],
            },
        },

    }),
};

const replacer = (key, value) => value instanceof Date ? value.toISOString() : value;
const reviver = (key, value) =>
    (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/))
        ? new Date(value)
        : value;
export const encode = (toDehydrate) => JSON.stringify(toDehydrate, replacer);
export const decode = (toRehydrate) => JSON.parse(toRehydrate, reviver);

const persistConfig = {
    key: 'root',
    storage: storageSession,
    whitelist: ['currentSearch'],
    version: 2,
    migrate: createMigrate(migrations, { debug: false }),
    transforms: [createTransform(encode, decode)],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default function reduxStore(initialState) {
    const store = createStore(
        persistedReducer,
        initialState,
        compose(
            applyMiddleware(thunk),
            devtools()
        ));
    const persistor = persistStore(store);
    return { store, persistor };
}
